import type { CustomElementEntry } from '../types'
import { DEFINITION_GETTER_NAME } from './constants'

const toPascalCase = (kebabCase: string): string =>
    kebabCase
        .split('-')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join('')

export const writeCustomElementsModule = (entries: CustomElementEntry[]): string => {
    if (entries.length === 0) {
        return ''
    }

    const elements: string[] = []

    for (const { tag, definition } of entries) {
        const className = toPascalCase(tag)
        const jsonDefinition = JSON.stringify(definition)

        elements.push(`class ${className} extends HTMLElement {
  static get ${DEFINITION_GETTER_NAME}() {
    return ${jsonDefinition};
  }
}
customElements.define('${tag}', ${className});`)
    }

    return elements.join('\n\n')
}
